<template>
    <v-container class="pa-5">
        <v-row v-for="(project, i) in projects" :key="i">
            <v-col cols="12">
                <v-card>
                    <v-img :src="project.logo" height="150px" contain></v-img>
                    <v-card-title>
                        {{ project.title }}
                    </v-card-title>
                    <v-card-subtitle>
                        {{ project.subtitle }}
                    </v-card-subtitle>
                    <v-card-actions>
                        <v-btn text @click="project.show = !project.show">
                            {{ project.show ? 'Esconder detalhes' : 'Ver detalhes' }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="project.show = !project.show">
                            <v-icon>{{ project.show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-expand-transition>
                        <div v-show="project.show">
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <span v-html="project.description" />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="text-h6">Principais ferramentas utilizadas</span>
                                    </v-col>
                                    <v-col v-for="(tool, x) in project.tools" :key="x" cols="auto">
                                        <v-chip :color="tool.color" dark>
                                            <v-icon left>{{ tool.icon }}</v-icon>
                                            {{ tool.title }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <v-row v-if="project.images">
                                    <v-col cols="12">
                                        <span class="text-h6">Galeria</span>
                                    </v-col>
                                    <v-col v-for="(image, k) in project.images" :key="k" class="d-flex child-flex" cols="4">
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-img
                                                    :src="image.file"
                                                    aspect-ratio="1.5"
                                                    class="grey lighten-2"
                                                    style="cursor: pointer;"
                                                    @click="openImageModal(image.file, image.description)"
                                                />
                                            </v-col>
                                            <v-col class="mt-1" cols="12">
                                                <span v-html="image.description" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="image_modal" max-width="1000">
            <v-row no-gutters>
                <v-col>
                    <v-img
                        :src="selected_image"
                        width="100%"
                        class="grey lighten-2"
                    >
                        <v-btn icon @click="closeImageModal">
                            <v-icon color="white">mdi-close</v-icon>
                        </v-btn>
                    </v-img>
                </v-col>
            </v-row>
            <v-row no-gutters class="white pa-4">
                <v-col>
                    <span v-html="selected_description" />
                </v-col>
            </v-row>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            image_modal: false,
            selected_image: null,
            selected_description: null,
            projects: [
                {
                    show: false,
                    logo: require('../../assets/projects/logo-melissa.png'),
                    title: "Psicologia Clínica Melissa Andrade",
                    subtitle: "Landing Page para divulgação de serviços de psicologia clínica",
                    description: "<p>Desenvolvi uma Landing Page para divulgar o trabalho de psicologia clínica da psicóloga Melissa Andrade.</p>"
                        + "<p>O site, acessível em <a href='https://melissaandrade.com.br' target='_blank'>melissaandrade.com.br</a>, foi construído utilizando NextJS e Tailwind CSS, proporcionando uma interface moderna e responsiva</p>"
                        + "<p>A página destaca os benefícios da terapia e conta com uma integração com o Instagram, exibindo automaticamente os últimos posts da profissional.</p>"
                        + "<p>Este projeto foi criado com foco em simplicidade e eficiência, oferecendo uma experiência visual atraente e uma navegação intuitiva para os visitantes</p>",
                    images: [],
                    tools: [
                        {
                            icon: "mdi-language-javascript",
                            title: "NextJS",
                            color: "#4f5b93"
                        },
                        {
                            icon: "mdi-tailwind",
                            title: "Tailwind CSS",
                            color: "#cf649a"
                        }
                    ]
                },
                {
                    show: false,
                    logo: require('../../assets/projects/melissa/admin-mel.png'),
                    title: "Melissa Andrade - Gestão de Clientes",
                    subtitle: "Gerenciamento de clientes de uma clínica de psicologia",
                    description: "<p>No início de 2023, identifiquei uma necessidade específica quando minha esposa decidiu migrar da psicologia organizacional para a psicologia clínica. Ela necessitava de uma ferramenta eficiente para organizar sua agenda de clientes, o que me motivou a desenvolver uma aplicação personalizada que atendesse a essas demandas.</p>"
                        + "<p>Aproveitei o projeto <b>Melvid - Controle Financeiro</b> como base, reutilizando a estrutura de código existente para acelerar o desenvolvimento. A partir daí, definimos juntos a identidade visual, a paleta de cores e as funcionalidades essenciais para o lançamento inicial, além de mapear possíveis evoluções futuras.</p>"
                        + "<p>Para desenvolver o sistema, utilizei Laravel 9 como a base do backend, criando uma REST API robusta que conecta eficientemente o frontend com o banco de dados. A interface foi construída em VueJS com Vuetify, proporcionando uma experiência de usuário moderna e responsiva. No armazenamento de dados, escolhi PostgreSQL, garantindo segurança e eficiência na gestão das informações. A aplicação foi implementada em dois containers Docker, isolando o ambiente de desenvolvimento e produção para fácil manutenção e escalabilidade. Finalmente, a hospedagem foi realizada na Google Cloud Platform, aproveitando um servidor pré-existente, com configuração de redirecionamento de portas para subdomínios específicos.</p>"
                        + "<p>Esse projeto entregou uma solução 100% personalizada para minha esposa, auxiliando na organização de sua agenda de psicologia clínica e melhorando significativamente sua eficiência no gerenciamento de atendimentos. Com uma estrutura escalável, a aplicação pode crescer junto com a demanda. A modularidade do código facilita manutenções futuras e permite a adição de novas funcionalidades. Além disso, automatiza tarefas repetitivas e libera tempo para que ela se dedique aos atendimentos, aumentando a produtividade.</p>"
                        + "<p>Planejo implementar integração com plataformas externas de calendário, como Google Calendar, para sincronizar automaticamente os compromissos e facilitar o gerenciamento da agenda. Além disso, considero adicionar dashboards para fornecer análises detalhadas sobre o crescimento da base de clientes e desempenho no atendimento. Em termos de segurança, pretendo introduzir camadas adicionais para proteger os dados sensíveis dos clientes, tornando a aplicação ainda mais robusta e confiável.</p>",
                    images: [
                        {
                            file: require('../../assets/projects/melissa/melissa-calendario1.png'),
                            description: "Tela inicial, exibe o calendario de atendimentos, ao clicar em um item do calendário é possível ver mais informações sobre aquele cliente, adicionar uma nova sessão ou um registro de pagamento."
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-list-sessao.png'),
                            description: "A partir das informações do calendário é possível ver a lista de sessões de um determinado cliente"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-add-sessao.png'),
                            description: "Modal de cadastro de sessão"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-add-pagamento.png'),
                            description: "Modal de cadastro de pagamento"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-calendario2.png'),
                            description: "Logo abaixo do calendário é possível observar as sessões que ainda não tem um prontuário montado, e sessões que ainda precisam ser estruturadas."
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-dashboard1.png'),
                            description: "Dashboard de acompanhamento, aqui é possível visualizar informações mês a mês, sobre o registro de sessões, registros financeiros, e também alertas sobre pagamentos atrasados, aniversarios, sessões do dia"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-clientes.png'),
                            description: "CRUD de clientes"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-recibos.png'),
                            description: "Através do sistema é possível gerar recibos para os clientes, de acordo com o valor que foi pago durante o mês"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-recibos2.png'),
                            description: "Modal de geração dos recibos"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-recibos3.png'),
                            description: "É possível filtrar os recibos que já foram gerados, e fazer o download novamente dos arquivos"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-sessoes.png'),
                            description: "CRUD de sessões"
                        },
                        {
                            file: require('../../assets/projects/melissa/melissa-programadas.png'),
                            description: "CRUD de despesas programadas"
                        }
                        
                    ],
                    tools: [
                        {
                            icon: "mdi-language-php",
                            title: "PHP 8",
                            color: "#4f5b93"
                        },
                        {
                            icon: "mdi-sass",
                            title: "SASS",
                            color: "#cf649a"
                        },
                        {
                            icon: "mdi-language-javascript",
                            title: "JavaScript",
                            color: "#f7df1e"
                        },
                        {
                            icon: "mdi-database",
                            title: "PostgreSQL",
                            color: "#316193"
                        },
                        {
                            icon: "mdi-api",
                            title: "RestAPI",
                            color: "primary"
                        },
                        {
                            icon: "mdi-laravel",
                            title: "Laravel",
                            color: "#ff2d20"
                        },
                        {
                            icon: "mdi-vuejs",
                            title: "VueJS",
                            color: "#00b981"
                        },
                        {
                            icon: "mdi-vuetify",
                            title: "Vuetify",
                            color: "#7bc6ff"
                        },
                        {
                            icon: "mdi-github",
                            title: "GitHub",
                            color: "black"
                        },
                        {
                            icon: "mdi-docker",
                            title: "Docker",
                            color: "#099cec"
                        }
                    ]
                },
                {
                    show: false,
                    logo: require('../../assets/projects/logo-melvid.png'),
                    title: "Melvid - Controle Financeiro",
                    subtitle: "Sistema de controle financeiro pessoal (Laravel + VueJS + PostgreSQL + GCloud)",
                    description: "<p>Em 2021, percebi que a gestão financeira pessoal por planilhas demandava muito tempo e esforço na manipulação dos dados. Após testar algumas alternativas, como o Mobills, e constatar que não atendiam minha rotina financeira, decidi criar uma aplicação personalizada, adequada ao meu dia a dia e às minhas necessidades específicas.</p>"
                        + "<p>A aplicação foi desenvolvida com Laravel 9 no backend, estruturada como uma REST API e implantada em dois containers Docker: um para a aplicação em si e outro para o servidor Nginx. No frontend, utilizei VueJS 2 e a biblioteca Vuetify para criar uma interface intuitiva e funcional. O armazenamento dos dados é feito com PostgreSQL, escolhido por sua robustez e eficiência. Todo o sistema foi implantado em um servidor Google Cloud, garantindo controle total sobre os recursos e a capacidade de escalar conforme necessário.</p>"
                        + "<p>A aplicação trouxe maior controle e flexibilidade para meu planejamento financeiro, eliminando a necessidade de planilhas e otimizando o tempo dedicado ao controle de receitas e despesas. A customização da plataforma permitiu que a gestão financeira se tornasse um processo ágil e prático, totalmente integrado às minhas necessidades e rotina. Além disso, a utilização de uma REST API e containers Docker facilita a manutenção e a escalabilidade, permitindo adaptações futuras conforme a necessidade.</p>"
                        + "<p>Planejo expandir a aplicação com funcionalidades como relatórios financeiros automáticos e dashboards de análise para uma visão completa e visual das finanças ao longo do tempo. Também estou avaliando a possibilidade de incorporar integração com bancos para importação direta de transações, simplificando ainda mais a gestão financeira e automatizando processos rotineiros.</p>",
                    images: [
                        {
                            file: require('../../assets/projects/melvid/melvid-dashboard1.png'),
                            description: "Dashboard do sistema, aqui é possível acompanhar todas as receitas e despesas, futuras e atuais, além das despesas de cartões e saldos."
                        },
                        {
                            file: require('../../assets/projects/melvid/melvid-dashboard2.png'),
                            description: "Grafico de acompanhamento mensal da dashboard."
                        },
                        {
                            file: require('../../assets/projects/melvid/melvid-cadastro-despesa.png'),
                            description: "Modal de inserção de registro de cartão de crédito"
                        },
                        {
                            file: require('../../assets/projects/melvid/melvid-cartoes.png'),
                            description: "CRUD de cartões"
                        },
                        {
                            file: require('../../assets/projects/melvid/melvid-contas.png'),
                            description: "CRUD de contas"
                        },
                        {
                            file: require('../../assets/projects/melvid/melvid-planejamento.png'),
                            description: "Planejamento de orçamento mensal para cada categoria de registros"
                        },
                        {
                            file: require('../../assets/projects/melvid/melvid-resumo1.png'),
                            description: "Resumo das despesas mensais de cada categoria"
                        },
                        {
                            file: require('../../assets/projects/melvid/melvid-resumo2.png'),
                            description: "Resumo das despesas mensais de cada categoria e sub-categoria"
                        }
                        
                    ],
                    tools: [
                        {
                            icon: "mdi-language-php",
                            title: "PHP 8",
                            color: "#4f5b93"
                        },
                        {
                            icon: "mdi-sass",
                            title: "SASS",
                            color: "#cf649a"
                        },
                        {
                            icon: "mdi-language-javascript",
                            title: "JavaScript",
                            color: "#f7df1e"
                        },
                        {
                            icon: "mdi-database",
                            title: "PostgreSQL",
                            color: "#316193"
                        },
                        {
                            icon: "mdi-api",
                            title: "RestAPI",
                            color: "primary"
                        },
                        {
                            icon: "mdi-laravel",
                            title: "Laravel",
                            color: "#ff2d20"
                        },
                        {
                            icon: "mdi-vuejs",
                            title: "VueJS",
                            color: "#00b981"
                        },
                        {
                            icon: "mdi-vuetify",
                            title: "Vuetify",
                            color: "#7bc6ff"
                        },
                        {
                            icon: "mdi-github",
                            title: "GitHub",
                            color: "black"
                        },
                        {
                            icon: "mdi-docker",
                            title: "Docker",
                            color: "#099cec"
                        }
                    ]
                },
                {
                    show: false,
                    logo: require("../../assets/experiences/logo_transmai.png"),
                    title: "Transmai Transportes",
                    subtitle: "Projeto envolvendo três aplicações sendo duas web e uma mobile",
                    description: "<p>Esse projeto foi desenvolvido para uma empresa de transportes que gerenciava cargas e frota manualmente, utilizando planilhas. Após analisar o funcionamento da operação, desenvolvi três aplicações para atender às necessidades específicas da empresa.</p>"
                        + "<p>A primeira aplicação foi construída com PHP e ZendFramework para gerenciar cargas e frota, utilizando PostgreSQL para armazenamento. A segunda foi um app mobile para Android em Java, permitindo que os motoristas acompanhassem o status das viagens e comunicassem atualizações. Para isso, criei uma API em Laravel que integrava os dados do app com o banco de dados existente. A terceira aplicação, construída em VueJS, foi um sistema financeiro que utiliza a mesma API do aplicativo para sincronizar informações de frota e cargas, consolidando o controle financeiro.</p>"
                        + "<p>As três aplicações integradas substituíram o sistema manual de controle da empresa, trazendo maior precisão e eficiência para a gestão de cargas, frota e finanças. O sistema permitiu aos motoristas atualizarem o status em tempo real e facilitou o controle financeiro, reduzindo o tempo de operação e melhorando a transparência das informações.</p>",
                    tools: [
                        {
                            icon: "mdi-language-php",
                            title: "PHP 7",
                            color: "#4f5b93"
                        },
                        {
                            icon: "mdi-application-braces",
                            title: "Smarty Template",
                            color: "primary"
                        },
                        {
                            icon: "mdi-zend",
                            title: "Zend Framework",
                            color: "#68b604"
                        },
                        {
                            icon: "mdi-jquery",
                            title: "JQuery",
                            color: "#1069ae"
                        },
                        {
                            icon: "mdi-language-html5",
                            title: "HTML 5",
                            color: "#e44d26"
                        },
                        {
                            icon: "mdi-language-css3",
                            title: "CSS 3",
                            color: "#1993c6"
                        },
                        {
                            icon: "mdi-language-javascript",
                            title: "JavaScript",
                            color: "#f7df1e"
                        },
                        {
                            icon: "mdi-database",
                            title: "PostgreSQL",
                            color: "#316193"
                        },
                        {
                            icon: "mdi-api",
                            title: "RestAPI",
                            color: "primary"
                        },
                        {
                            icon: "mdi-language-java",
                            title: "Java Android",
                            color: "#eb1f24"
                        },
                        {
                            icon: "mdi-laravel",
                            title: "Laravel",
                            color: "#ff2d20"
                        },
                        {
                            icon: "mdi-vuejs",
                            title: "VueJS",
                            color: "#00b981"
                        },
                        {
                            icon: "mdi-github",
                            title: "GitHub",
                            color: "black"
                        }
                    ]
                }
            ]
        };
    },
    methods: {
        openImageModal(imageSrc, imageDescription) {
            this.selected_image = imageSrc;
            this.selected_description = imageDescription;
            this.image_modal = true;
        },
        closeImageModal() {
            this.selected_image = null;
            this.selected_description = null;
            this.image_modal = false;
        }
    }
};
</script>